module.exports = __webpack_public_path__ + "static/media/Inverness_Alloa.42bce109.pdf";